module.exports = __webpack_public_path__ + "4aa04ce3aad03d0b3909cea4af5947d7.mp3";